import { throttle } from './utils';

export default class Accordion {
  private panel: HTMLElement;
  private btn: HTMLElement;
  private links: HTMLElement[];

  constructor(el: HTMLElement) {
    this.panel = el.querySelector('.js-accordion-panel') as HTMLElement;
    this.btn = el.querySelector('.js-accordion-toggle') as HTMLElement;
    this.links = Array.from(
      this.panel.querySelectorAll<HTMLElement>('a, iframe, button, input, video')
    );

    if (!this.panel || !this.btn) {
      console.error('Accordion panel or button not found');
      return;
    }

    // Set initial max-height for any accordions that are expanded by default,
    // and enable/disable links
    if (this.isOpen()) {
      // Set initial max-height for any accordions that are expanded by default
      this.panel.style.maxHeight = `${this.panel.scrollHeight}px`;
      this.enableLinks();
    } else {
      this.panel.setAttribute('aria-hidden', 'true');
      this.disableLinks();
    }
  }

  /**
   * Make binding events optional so you can instantiate them
   * and open/close without it adding duplicate event listeners
   */
  public bindEvents() {
    this.btn.addEventListener('click', (e)=> {
      e.preventDefault;
      this.toggle();
    });

    // Set height of panels on resize (e.g. from desktop to mobile)
    window.addEventListener('resize', throttle(() => {
      if (!this.isOpen()) {
        return;
      }

      this.panel.style.maxHeight = `${this.panel.scrollHeight}px`;
    }, 200));
  }

  private isOpen() {
    return this.panel.classList.contains('open');
  }

  /** Enable links inside the panel */
  private enableLinks() {
    this.links.forEach((link) => {
      link.setAttribute('tabindex', '0');
    });
  }

  /** Disable links inside the panel */
  private disableLinks() {
    this.links.forEach((link) => {
      link.setAttribute('tabindex', '-1');
    });
  }

  /** Open the panel */
  public open() {
    if (this.isOpen()) {
      return;
    }

    this.btn.classList.add('open');
    this.panel.style.maxHeight = `${this.panel.scrollHeight}px`;
    this.panel.classList.add('open');
    this.panel.removeAttribute('aria-hidden');
    this.enableLinks();

    // this.closeOtherPanels();
  }

  /** Close the panel */
  public close() {
    if (!this.isOpen()) {
      return;
    }

    this.btn.classList.remove('open');
    this.panel.style.maxHeight = '';
    this.panel.classList.remove('open');
    this.panel.setAttribute('aria-hidden', 'true');
    this.disableLinks();
  }

  /**
   * Toggle or set open/closed state
   * @param open - Optional boolean to force open or close
   */
  public toggle(open?: boolean) {
    switch (open) {
      case true:
        this.open();
        break;
      case false:
        this.close();
        break;
      default:
        this.isOpen() ? this.close() : this.open();
    }
  }
}
